import { SubprojectInfo, TaskPipelineName } from '@scale/shared-types';
import React from 'react';
import ObjectBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ObjectBuilder';
import { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';
import { SubprojectInfoBuilderSchema } from '@scale/shared/pipelinev3/sensor-fusion/index';
import { Button } from '@scale/scaleui';

interface SubprojectInfoConfigsBuilderProps {
  name: string;
  existingValue?: SubprojectInfo;
  updateProperty: (arg: SubprojectInfo | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const SubprojectInfoConfigsBuilder: React.FC<SubprojectInfoConfigsBuilderProps> = ({
  name,
  existingValue = undefined,
  updateProperty,
  typeBuilderMap,
}) => {
  const config = existingValue;
  const [showBuilder, setShowBuilder] = React.useState<boolean>(false);

  const addConfig = () => {
    updateProperty({
      subprojectKey: '',
      stageDefinitionIds: [],
      v2PipelineName: TaskPipelineName.StandardTask,
    });
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-lg">{name}</div>}
      {config && (
        <ObjectBuilder
          typeBuilderMap={typeBuilderMap}
          title={'Config'}
          object={config}
          schema={SubprojectInfoBuilderSchema}
          updateObject={(newElement: SubprojectInfo) => updateProperty(newElement)}
          deleteObject={() => updateProperty(undefined)}
          showBuilder={showBuilder}
          toggleShowBuilder={() => {
            setShowBuilder(showBuilder => !showBuilder);
          }}
        />
      )}
      {!config && <Button onClick={() => addConfig()}>Add {name} Config</Button>}
    </div>
  );
};

export default SubprojectInfoConfigsBuilder;
